export default __webpack_public_path__ + "static/media/dasboard.43fa5b97.svg";